import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  _Dimension___init__impl__44fy0dh4lhk0zw2tim as _Dimension___init__impl__44fy0d,
  _Dimension___get_value__impl__urhqzrblez9tu1bx9v as _Dimension___get_value__impl__urhqzr,
} from './data.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  PerCorner27xb33zgvi5gv as PerCorner,
  RatioOfSpacing2du8cst35dyuc as RatioOfSpacing,
  RatioOfSize1ip5bd7oxn8ba as RatioOfSize,
  Fixed1p8lc8swyflir as Fixed,
  AdaptiveToSpacing2muzuvljgg8be as AdaptiveToSpacing,
} from './CornerRadii.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { checkIndexOverflow3frtmheghr0th as checkIndexOverflow } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  RadialGradient3ic79yys0k1fp as RadialGradient,
  LinearGradient2qftccjwl6uey as LinearGradient,
  Companion_getInstance2u620q9r4ejbj as Companion_getInstance,
  Color17ck47lkedxoy as Color,
  FadingColor3d6ef6zcqmlhk as FadingColor,
} from './Paint.mjs';
import { _Angle___get_turns__impl__atdtw5psbuz3qdt26e as _Angle___get_turns__impl__atdtw5 } from './Angle.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_rem(_this__u8e3s4) {
  return Dimension(VOID, _this__u8e3s4);
}
function Dimension(px, rem) {
  px = px === VOID ? 0.0 : px;
  rem = rem === VOID ? 0.0 : rem;
  return _Dimension___init__impl__44fy0d(new (DimensionRaw())(px, rem));
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.zero_1 = new (DimensionRaw())();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var DimensionRawClass;
function DimensionRaw() {
  if (DimensionRawClass === VOID) {
    class $ {
      constructor(px, rem) {
        Companion_getInstance_0();
        px = px === VOID ? 0.0 : px;
        rem = rem === VOID ? 0.0 : rem;
        this.px_1 = px;
        this.rem_1 = rem;
      }
      get_roughPx_o6ay0o_k$() {
        return this.px_1 + this.rem_1 * 16;
      }
      toString() {
        return this.px_1 === 0.0 ? '' + this.rem_1 + 'rem' : this.rem_1 === 0.0 ? '' + this.px_1 + 'px' : 'calc(' + this.px_1 + 'px + ' + this.rem_1 + 'rem)';
      }
      compareTo_cq7t30_k$(other) {
        return compareTo(this.get_roughPx_o6ay0o_k$(), other.get_roughPx_o6ay0o_k$());
      }
      compareTo_hpufkf_k$(other) {
        return this.compareTo_cq7t30_k$(other instanceof DimensionRaw() ? other : THROW_CCE());
      }
      hashCode() {
        var result = getNumberHashCode(this.px_1);
        result = imul(result, 31) + getNumberHashCode(this.rem_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DimensionRaw()))
          return false;
        if (!equals(this.px_1, other.px_1))
          return false;
        if (!equals(this.rem_1, other.rem_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DimensionRaw', DimensionRaw, VOID, [Comparable()]);
    DimensionRawClass = $;
  }
  return DimensionRawClass;
}
function get_rem_0(_this__u8e3s4) {
  return Dimension(VOID, _this__u8e3s4);
}
var FontClass;
function Font() {
  if (FontClass === VOID) {
    class $ {
      constructor(cssFontFamilyName, url, fallback, direct) {
        url = url === VOID ? null : url;
        fallback = fallback === VOID ? 'Helvetica' : fallback;
        direct = direct === VOID ? null : direct;
        this.cssFontFamilyName_1 = cssFontFamilyName;
        this.url_1 = url;
        this.fallback_1 = fallback;
        this.direct_1 = direct;
      }
      toString() {
        return 'Font(cssFontFamilyName=' + this.cssFontFamilyName_1 + ', url=' + this.url_1 + ', fallback=' + this.fallback_1 + ', direct=' + toString_0(this.direct_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.cssFontFamilyName_1);
        result = imul(result, 31) + (this.url_1 == null ? 0 : getStringHashCode(this.url_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.fallback_1) | 0;
        result = imul(result, 31) + (this.direct_1 == null ? 0 : this.direct_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Font()))
          return false;
        if (!(this.cssFontFamilyName_1 === other.cssFontFamilyName_1))
          return false;
        if (!(this.url_1 == other.url_1))
          return false;
        if (!(this.fallback_1 === other.fallback_1))
          return false;
        if (!equals(this.direct_1, other.direct_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Font');
    FontClass = $;
  }
  return FontClass;
}
function get_systemDefaultFont() {
  return new (Font())("'Montserrat'", 'https://fonts.googleapis.com/css2?family=Montserrat:wght@100;400;700&display=swap', 'Helvetica');
}
function get_px(_this__u8e3s4) {
  return Dimension(_this__u8e3s4);
}
function get_dp(_this__u8e3s4) {
  return Dimension(_this__u8e3s4);
}
function get_systemDefaultFixedWidthFont() {
  return new (Font())('monospace');
}
function times(_this__u8e3s4, other) {
  return Dimension(_Dimension___get_value__impl__urhqzr(_this__u8e3s4).px_1 * other, _Dimension___get_value__impl__urhqzr(_this__u8e3s4).rem_1 * other);
}
function div(_this__u8e3s4, other) {
  return Dimension(_Dimension___get_value__impl__urhqzr(_this__u8e3s4).px_1 / other, _Dimension___get_value__impl__urhqzr(_this__u8e3s4).rem_1 / other);
}
var ImageSourceClass;
function ImageSource() {
  if (ImageSourceClass === VOID) {
    class $ {
      static new_com_lightningkite_kiteui_models_ImageSource_p790jq_k$() {
        return createThis(this);
      }
    }
    initMetadataForClass($, 'ImageSource');
    ImageSourceClass = $;
  }
  return ImageSourceClass;
}
var FontDirectClass;
function FontDirect() {
  if (FontDirectClass === VOID) {
    class $ {
      constructor(normal, italics) {
        this.normal_1 = normal;
        this.italics_1 = italics;
      }
      toString() {
        return 'FontDirect(normal=' + toString(this.normal_1) + ', italics=' + toString(this.italics_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.normal_1);
        result = imul(result, 31) + hashCode(this.italics_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FontDirect()))
          return false;
        if (!equals(this.normal_1, other.normal_1))
          return false;
        if (!equals(this.italics_1, other.italics_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'FontDirect');
    FontDirectClass = $;
  }
  return FontDirectClass;
}
function plus(_this__u8e3s4, other) {
  return Dimension(_Dimension___get_value__impl__urhqzr(_this__u8e3s4).px_1 + _Dimension___get_value__impl__urhqzr(other).px_1, _Dimension___get_value__impl__urhqzr(_this__u8e3s4).rem_1 + _Dimension___get_value__impl__urhqzr(other).rem_1);
}
function toRawCornerRadius(_this__u8e3s4, scaleCssVar) {
  scaleCssVar = scaleCssVar === VOID ? null : scaleCssVar;
  var tmp;
  if (_this__u8e3s4 instanceof AdaptiveToSpacing()) {
    tmp = toRawCornerRadius$scaled('calc(min(var(--parentSpacing, 0px), ' + _Dimension___get_value__impl__urhqzr(_this__u8e3s4.value_1).toString() + '))', scaleCssVar);
  } else {
    if (_this__u8e3s4 instanceof Fixed()) {
      tmp = toRawCornerRadius$scaled(_Dimension___get_value__impl__urhqzr(_this__u8e3s4.value_1).toString(), scaleCssVar);
    } else {
      if (_this__u8e3s4 instanceof RatioOfSize()) {
        tmp = scaleCssVar == null ? '' + numberToInt(_this__u8e3s4.ratio_1 * 100) + '%' : 'calc(' + numberToInt(_this__u8e3s4.ratio_1 * 100) + '% * var(' + scaleCssVar + '))';
      } else {
        if (_this__u8e3s4 instanceof RatioOfSpacing()) {
          tmp = scaleCssVar == null ? 'calc(var(--parentSpacing, 0px) * ' + _this__u8e3s4.value_1 + ')' : 'calc(var(--parentSpacing, 0px) * ' + _this__u8e3s4.value_1 + ' * var(' + scaleCssVar + '))';
        } else {
          if (_this__u8e3s4 instanceof PerCorner()) {
            var tmp_0 = listOf([_this__u8e3s4.topLeft_1, _this__u8e3s4.topRight_1, _this__u8e3s4.bottomRight_1, _this__u8e3s4.bottomLeft_1]);
            tmp = joinToString(tmp_0, ' ', VOID, VOID, VOID, VOID, (it) => it ? toRawCornerRadius$scaled(_Dimension___get_value__impl__urhqzr(_this__u8e3s4.value_1).toString(), scaleCssVar) : '0px');
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
  }
  return tmp;
}
var ImageResourceClass;
function ImageResource() {
  if (ImageResourceClass === VOID) {
    class $ extends ImageSource() {
      constructor(relativeUrl) {
        return new.target.new_com_lightningkite_kiteui_models_ImageResource_isu8ml_k$(relativeUrl);
      }
      static new_com_lightningkite_kiteui_models_ImageResource_isu8ml_k$(relativeUrl) {
        var $this = this.new_com_lightningkite_kiteui_models_ImageSource_p790jq_k$();
        $this.relativeUrl_1 = relativeUrl;
        return $this;
      }
      toString() {
        return 'ImageResource(relativeUrl=' + this.relativeUrl_1 + ')';
      }
      hashCode() {
        return getStringHashCode(this.relativeUrl_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ImageResource()))
          return false;
        if (!(this.relativeUrl_1 === other.relativeUrl_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ImageResource');
    ImageResourceClass = $;
  }
  return ImageResourceClass;
}
function get_dp_0(_this__u8e3s4) {
  return Dimension(_this__u8e3s4);
}
function vectorToSvgDataUrl(_this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
  this_0.append_22ad7x_k$('<?xml version="1.0" encoding="UTF-8"?>');
  this_0.append_22ad7x_k$('<svg xmlns="http://www.w3.org/2000/svg" width="' + _Dimension___get_value__impl__urhqzr(_this__u8e3s4.width_1).toString() + '" height="' + _Dimension___get_value__impl__urhqzr(_this__u8e3s4.height_1).toString() + '" viewBox="' + _this__u8e3s4.viewBoxMinX_1 + ' ' + _this__u8e3s4.viewBoxMinY_1 + ' ' + _this__u8e3s4.viewBoxWidth_1 + ' ' + _this__u8e3s4.viewBoxHeight_1 + '">');
  this_0.append_22ad7x_k$('<defs>');
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var _iterator__ex2g4s = _this__u8e3s4.paths_1.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    var p = item.fillColor_1;
    if (p instanceof LinearGradient()) {
      // Inline function 'com.lightningkite.kiteui.models.Angle.degrees' call
      var this_1 = p.angle_1;
      var tmp$ret$5 = _Angle___get_turns__impl__atdtw5(this_1) * 360.0;
      this_0.append_22ad7x_k$('<linearGradient id="fill' + index_0 + '" gradientTransform="rotate(' + tmp$ret$5 + ', 0.5, 0.5)">');
      var _iterator__ex2g4s_0 = p.stops_1.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
        var stop = _iterator__ex2g4s_0.next_20eer_k$();
        this_0.append_22ad7x_k$('<stop stop-color="' + stop.color_1.toAlphalessWeb_15mha0_k$() + '" stop-opacity="' + stop.color_1.alpha_1 + '" offset="' + numberToInt(stop.ratio_1 * 100) + '%"/>');
      }
      this_0.append_22ad7x_k$('<\/linearGradient>');
    } else {
      if (p instanceof RadialGradient()) {
        this_0.append_22ad7x_k$('<radialGradient id="fill' + index_0 + '">');
        var _iterator__ex2g4s_1 = p.stops_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
          var stop_0 = _iterator__ex2g4s_1.next_20eer_k$();
          this_0.append_22ad7x_k$('<stop stop-color="' + stop_0.color_1.toAlphalessWeb_15mha0_k$() + '" stop-opacity="' + stop_0.color_1.alpha_1 + '" offset="' + numberToInt(stop_0.ratio_1 * 100) + '%"/>');
        }
        this_0.append_22ad7x_k$('<\/radialGradient>');
      }
    }
  }
  this_0.append_22ad7x_k$('<\/defs>');
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index_1 = 0;
  var _iterator__ex2g4s_2 = _this__u8e3s4.paths_1.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
    var item_0 = _iterator__ex2g4s_2.next_20eer_k$();
    var _unary__edvuaz_0 = index_1;
    index_1 = _unary__edvuaz_0 + 1 | 0;
    var index_2 = checkIndexOverflow(_unary__edvuaz_0);
    var tmp0_safe_receiver = item_0.strokeColor_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toWeb_1tsvdl_k$();
    var tmp = tmp1_elvis_lhs == null ? Companion_getInstance().transparent_1.toWeb_1tsvdl_k$() : tmp1_elvis_lhs;
    var tmp2_elvis_lhs = item_0.strokeWidth_1;
    var tmp_0 = toString(tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs);
    var f = item_0.fillColor_1;
    var tmp_1;
    if (f instanceof LinearGradient()) {
      tmp_1 = 'url(#fill' + index_2 + ')';
    } else {
      if (f instanceof RadialGradient()) {
        tmp_1 = 'url(#fill' + index_2 + ')';
      } else {
        if (f instanceof FadingColor()) {
          tmp_1 = f.base_1.toWeb_1tsvdl_k$();
        } else {
          if (f instanceof Color()) {
            tmp_1 = f.toWeb_1tsvdl_k$();
          } else {
            tmp_1 = Companion_getInstance().transparent_1.toWeb_1tsvdl_k$();
          }
        }
      }
    }
    this_0.append_22ad7x_k$('<path fill-rule="evenodd" d="' + item_0.path_1 + '" stroke="' + tmp + '" stroke-width="' + tmp_0 + '" fill="' + tmp_1 + '"/>');
  }
  this_0.append_22ad7x_k$('<\/svg>');
  var tmp$ret$0 = this_0.toString();
  return 'data:image/svg+xml;utf8,' + encodeURIComponent(tmp$ret$0);
}
function toRawCornerRadius$scaled(_this__u8e3s4, $scaleCssVar) {
  return $scaleCssVar == null ? _this__u8e3s4 : 'calc((' + _this__u8e3s4 + ') * var(' + $scaleCssVar + '))';
}
//region block: exports
export {
  FontDirect as FontDirect3ifj3qs5hfije,
  Font as Font1uq8v2r7qm3xe,
  ImageResource as ImageResource1861inqz1dzjl,
  ImageSource as ImageSource1gw5x4v78u21a,
  div as divc3x3x4wqw206,
  get_dp as get_dp28ag147e4p5cz,
  get_dp_0 as get_dp246mt9ygxfnpl,
  plus as plus2opbwe063z9pg,
  get_px as get_px8ok5q0jdway2,
  get_rem as get_rem14pbkv8p42gid,
  get_rem_0 as get_rem2p56fiaxda5jo,
  get_systemDefaultFixedWidthFont as get_systemDefaultFixedWidthFont14cv3wy0prdkq,
  get_systemDefaultFont as get_systemDefaultFont25t9j5zn5vlep,
  times as times16x024lmmohdt,
  toRawCornerRadius as toRawCornerRadius19avvfrnu4o3m,
  vectorToSvgDataUrl as vectorToSvgDataUrl2gfp16zcspd2w,
  Companion_getInstance_0 as Companion_getInstance2s2nvbwu43fem,
};
//endregion

//# sourceMappingURL=data.commonHtml.mjs.map
